import {TagAuth} from "~/constants/Tags";
import {statisticsAPI} from "~/api/statisticsAPI";

export const enhancedStatisticsAPI = statisticsAPI.enhanceEndpoints({
    addTagTypes: [TagAuth],
    endpoints: {
        getStatisticsDashboardSummary: {providesTags: () => [{type: TagAuth, id: "current"}]},
        getStatisticsRequests: {providesTags: () => [{type: TagAuth, id: "current"}]},
        getStatisticsUsage: {providesTags: () => [{type: TagAuth, id: "current"}]},
        getStatisticsSummary: {providesTags: () => [{type: TagAuth, id: "current"}]},
    }
});

export const {
    useGetStatisticsDashboardSummaryQuery,
    useLazyGetStatisticsDashboardSummaryQuery,
    useGetStatisticsRequestsQuery,
    useLazyGetStatisticsRequestsQuery,
    useGetStatisticsSummaryQuery,
    useLazyGetStatisticsSummaryQuery,
    useGetStatisticsUsageQuery,
    useLazyGetStatisticsUsageQuery,
} = enhancedStatisticsAPI;